import { useSearchParams } from '~/hooks/useSearchParams';

export const useIsAnonymousRecordWorkflow = (): boolean => {
  const [searchParams] = useSearchParams();

  if (searchParams instanceof URLSearchParams) {
    const origin: string | null = searchParams.get('origin');
    return origin === 'record_anon';
  }

  return false;
};
